import {
  alias,
  extend,
  params,
  string as stringType,
  shape as shapeType,
  bool as boolType,
  arrayOf as arrayOfType
} from '@thd-nucleus/data-sources';
import { SAMCalculator } from '@thd-olt-component-react/calculator';
import { ScheduleAMeasureCta, GccCarpetSamCta } from '@thd-olt-component-react/home-services-cta-buttons';

export const dataModel = extend({
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    installServices: params({ storeId: stringType() }).shape({
      scheduleAMeasure: boolType()
    }),
    taxonomy: shapeType({
      breadCrumbs: arrayOfType(shapeType({
        label: stringType()
      }))
    })
  }),
  clientOnlyProduct: alias('product').params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    installServices: params({ storeId: stringType() }).shape({
      gccCarpetDesignAndOrderEligible: boolType()
    })
  })
}, SAMCalculator, ScheduleAMeasureCta, GccCarpetSamCta);
